import { useParams } from '@tanstack/react-router';

import { kinds } from '@/app/site/scope';
import { useSiteScope } from '@/app/site/useSiteScope';
import { MediaLibrary } from '@/features/media/MediaLibrary';
import { OptimizationDialog } from '@/features/media/OptimizationDialog';

import styles from './MediaPage.module.scss';

/**
 * Медиатека окружения: картинки, видео, аудио и документы по папкам. Своя у
 * Production и у Development (docs/research/09-media.md) — переключатель
 * окружения сверху меняет и её.
 */
export function MediaPage() {
  const { siteId, env } = useParams({ from: '/authed/sites/$siteId/$env/media' });
  const scope = useSiteScope();

  return (
    <div className={styles['page']}>
      <header className={styles['head']}>
        <div className={styles['head__text']}>
          <h1 className={styles['title']}>Медиа</h1>
          <p className={styles['muted']}>
            Картинки, видео, аудио и документы окружения. Перетащите файлы на экран, чтобы
            загрузить, и на папку слева, чтобы переложить.
          </p>
        </div>
        <OptimizationDialog
          siteId={siteId}
          env={kinds[env]}
          canShape={scope?.canShared('site.shape') ?? false}
          canWrite={scope?.can('content.write') ?? false}
        />
      </header>

      <MediaLibrary
        key={`${siteId}:${env}`}
        siteId={siteId}
        env={kinds[env]}
        canWrite={scope?.can('content.write') ?? false}
        canRemove={scope?.can('content.publish') ?? false}
      />
    </div>
  );
}
